import { useBlogItemContext } from '../Context'

export const useBlogPageTitle = (): string => {
  const { document, loading } = useBlogItemContext()

  if (loading || !document?.title) {
    return 'Blog'
  }

  return `Blog - ${document.title}`
}
